import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div<any>`
  width: 100%;

  form {
    display: flex;
    align-items: center;
    padding: 0 30px !important;
    ${props => props.multipleLines && `
      flex-wrap: wrap;

      .second-line {
        width: 100%;

        > div {
          display: inline-block;
          margin-right: 10px;
        }

        p {
          margin-top: 0;
          font: ${font('default', 'bold', '12px/1')};
        }
      }
    `}

    ${bp('sm')`
      flex-wrap: wrap;

      > div {
        padding-bottom: 15px;
      }
    `}

    > div {
      margin-right: 10px;

      label {
        span {
          font: ${font('default', 'normal', '14px/1.5')};
        }
      }
    }

    button {
      margin-bottom: 5px;

      > div {
        padding: 10px 15px;
      }
    }
  }
`
